var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7494_29523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66078 8.06571L0.129739 11.6117C-0.0432463 11.8659 -0.0432463 12.2599 0.129739 12.5141L2.66078 16.0601C2.94302 16.4668 3.43466 16.1745 3.43466 15.6153V13.3275H8.90645C9.4072 13.3275 9.8169 12.7556 9.8169 12.0566C9.8169 11.3575 9.4072 10.7856 8.90645 10.7856H3.43466V8.51055C3.43466 7.93861 2.94302 7.659 2.66078 8.06571ZM15.8714 3.98589L13.3403 0.439876C13.0581 0.0331653 12.5665 0.325489 12.5665 0.884717V3.15976H7.08556C6.58481 3.15976 6.17511 3.73169 6.17511 4.43073C6.17511 5.12976 6.58481 5.7017 7.08556 5.7017H12.5573V7.97674C12.5573 8.54868 13.049 8.82829 13.3312 8.42158L15.8623 4.87557C16.0444 4.63408 16.0444 4.22737 15.8714 3.98589Z",
    fill: "#0B0C0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7494_29523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/icon-left.455fa1bf55da120ee8c986b4bd9ca715.svg";
export { ForwardRef as ReactComponent };